import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { GHG_ESTIMATOR_CONCEPT_ID, IMPACT_CARRY_CONCEPT_ID, IMPACT_STRATEGY_CONCEPT_ID, isCustomImpactConceptId } from '~/constants/concepts';
export default /*#__PURE__*/_defineComponent({
  __name: 'impactVentureInformation',
  props: {
    impactGoal: {
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var loading = computed(function () {
      return props.loading;
    });
    var climateImpact = computed(function () {
      var _props$impactGoal;
      return (_props$impactGoal = props.impactGoal) === null || _props$impactGoal === void 0 ? void 0 : _props$impactGoal.impacts.find(function (impact) {
        return impact.conceptId === GHG_ESTIMATOR_CONCEPT_ID;
      });
    });
    var tocImpact = computed(function () {
      var _props$impactGoal2;
      return (_props$impactGoal2 = props.impactGoal) === null || _props$impactGoal2 === void 0 ? void 0 : _props$impactGoal2.impacts.find(function (impact) {
        return impact.conceptId === IMPACT_STRATEGY_CONCEPT_ID;
      });
    });
    var carryImpacts = computed(function () {
      var _props$impactGoal$imp, _props$impactGoal3;
      return ((_props$impactGoal$imp = (_props$impactGoal3 = props.impactGoal) === null || _props$impactGoal3 === void 0 ? void 0 : _props$impactGoal3.impacts) !== null && _props$impactGoal$imp !== void 0 ? _props$impactGoal$imp : []).filter(function (impact) {
        return Number(impact.conceptId) === IMPACT_CARRY_CONCEPT_ID;
      });
    });
    var customImpacts = computed(function () {
      var _props$impactGoal$imp2, _props$impactGoal4;
      return ((_props$impactGoal$imp2 = (_props$impactGoal4 = props.impactGoal) === null || _props$impactGoal4 === void 0 ? void 0 : _props$impactGoal4.impacts) !== null && _props$impactGoal$imp2 !== void 0 ? _props$impactGoal$imp2 : []).filter(function (impact) {
        return isCustomImpactConceptId(impact.conceptId);
      });
    });
    var usingGhgTool = computed(function () {
      var _props$impactGoal5;
      return (_props$impactGoal5 = props.impactGoal) === null || _props$impactGoal5 === void 0 ? void 0 : _props$impactGoal5.impacts.some(function (impact) {
        var _impact$concept;
        return ((_impact$concept = impact.concept) === null || _impact$concept === void 0 ? void 0 : _impact$concept.id) === GHG_ESTIMATOR_CONCEPT_ID && impact.impactSolutions.some(function (solution) {
          return solution.useGhgSavingPotentialTool;
        });
      });
    });
    return {
      __sfc: true,
      props: props,
      loading: loading,
      climateImpact: climateImpact,
      tocImpact: tocImpact,
      carryImpacts: carryImpacts,
      customImpacts: customImpacts,
      usingGhgTool: usingGhgTool
    };
  }
});